import Backbone from 'init/backbone'
import { Defaults } from 'es-decorators'
import { ItemQtyView } from 'es6/views/item-qty-view'
import { getTemplate } from 'helpers/template-helper'

/**
 * Вид для блока с количеством и кнопкой "в корзине" для рекомендованных товаров
 */
@Defaults({
  template: '.recommendations-btn-template',
  additionalOptions: ['item', 'template', 'isCart'],
})
export class RecommendationsItemQtyView extends ItemQtyView {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate(this.template)
    // добавили товар в корзину
    this.listenTo(this.cart, 'clear', this.remove)
    this.listenTo(this.cart, 'removeCheckedFromCart', this.removeFromRecommendationList)
    this.minimum = this.item.get('minQty')
    this.maximum = this._initMaximum()
    this.render({ controls: [false, false] })
  }

  /**
   * Рисуем блок
   * @param {Object} options
   * @returns {RecommendationsItemQtyView} инициализированная вью
   */
  render (options) {
    let qty = this.model.get('qty')
    if (qty && this.item.get('has_custom_qty_units')) {
      qty = this.convertQtyBasedOnNestedUnit(qty, this.item.get('in_set'), 'to')
    }
    // рендерим html
    this.$el.html(this.template({
      visibleQty: this.getVisibleValue(qty),
      qty: qty,
      model: this.model.toJSON(),
      qtyRule: this.getQtyRule(),
    }))
    // инициализируем внутренние переменные
    this.qtyBtn = this.$('.qty-btn')
    this.input = this.$('[data-cart-input]')
    this.btn = this.$('.button[data-action=add]')
    this.value = this.model.get('qty')
    this.$('.input__increase').hide()
    this.$('.input__decrease').hide()
    this.updateControls(options.controls[0], false)
    return this
  }

  /**
   * Обновление статуса товара при попадании в корзину
   */
  updateCartStatus () {
    if (this.model.get('qty') > 0) {
      this.qtyBtn.addClass('incart')
      this.input.val(this.model.get('qty'))
      this.updateControls()
    }
  }

  /**
   * Удаляем товар из корзины рекомендаций
   * @param {Array} ids Массив с id товара, удаленного из корзины
   */
  removeFromRecommendationList (ids = []) {
    if (ids.includes(this.model.get('id'))) {
      Backbone.trigger('update-cart-item', this.model, 'delete')
    }
  }
}
